
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { UserProvider } from './contexts/UserContext';
import { StoreProvider } from './contexts/StoreContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { NotificationProvider } from './components/Notification';

console.log('Starting app...');

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("Root element not found!");
  throw new Error("Could not find root element to mount to");
}

console.log('Root element found, creating root...');

try {
  const root = ReactDOM.createRoot(rootElement);
  console.log('Root created, rendering app...');

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <NotificationProvider>
          <UserProvider>
            <StoreProvider>
              <App />
            </StoreProvider>
          </UserProvider>
        </NotificationProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  console.log('App rendered successfully!');
} catch (error) {
  console.error('Error rendering app:', error);
  rootElement.innerHTML = `
    <div style="padding: 20px; font-family: Arial; text-align: center;">
      <h1 style="color: red;">خطأ في تحميل التطبيق</h1>
      <p>${error instanceof Error ? error.message : 'خطأ غير معروف'}</p>
      <button onclick="window.location.reload()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer;">
        إعادة تحميل الصفحة
      </button>
    </div>
  `;
}
